import { motion } from 'motion/react';

import aiVideo from '#core/assets/video/agent/3.mp4?url';

import classes from './AtlasAiHero.module.css';
import { AtlasAiTitle } from './AtlasAiTitle.tsx';
import { agentTransition } from './transitions.ts';

const defaultChildren = <AtlasAiTitle />;

/** Animated hero section for Atlas AI chat interface with video spinner and customizable content. */
export function AtlasAiHero({ children = defaultChildren }: React.PropsWithChildren) {
  return (
    <motion.div animate="show" className={classes.hero} exit="exit" initial="hidden" layout>
      <motion.div className={classes.agent} variants={agentTransition}>
        {/* playsInline prevents fullscreen on mobile Safari */}
        <video autoPlay className={classes.spinner} loop muted playsInline>
          <source src={aiVideo} type="video/mp4" />
        </video>
      </motion.div>

      {children}
    </motion.div>
  );
}
